

import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { apiUrlComponent } from '../common/api.url.component';
import { ApiService } from '../common/API/api.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import * as XLSX from 'ts-xlsx';
import { NotifierService } from 'angular-notifier';
import { WorkBook } from 'xlsx';
import { VALID } from '@angular/forms/src/model';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { BackRestrict } from '../common/backRestrict'
import { from } from 'rxjs';
import * as $ from 'jquery';

declare var config;



@Component({
  selector: 'app-device-model-alias',
  templateUrl: './device-model-alias.component.html',
  styleUrls: ['./device-model-alias.component.css']
})
export class DeviceModelAliasComponent implements OnInit {
  DeviceModelID: any;
  DeviceModelName: any;
  public Enterprisedata = [];
  public form: FormGroup;
  public TitleUpdate = "Update Data";
  public Title_Update = false;
  public Title_Add = false;
  public TitleAdd: boolean = true;
  private readonly notifier: NotifierService;
  public Enterpriselist = [];


  @ViewChild(MatPaginator) paginator: MatPaginator;
  public pageSizeOptions = [5, 10, 15, 20];
  public pageSize = 10;
  public length = 10;
  public displayedColumns = ['SKUID', 'DeviceModelID', 'DeviceModelFullName', 'DeviceVendor', 'StorageCapacity', 'DeviceColor'];



  constructor(private _apiService: ApiService, private backrestrict: BackRestrict, private formbuilder: FormBuilder,
    private apiUrl: apiUrlComponent, notifierService: NotifierService, private spinner: NgxSpinnerService) {

    this.form = formbuilder.group({
      DeviceBrand: ['', Validators.required],
      OperatingSystem: ['', Validators.required]
    });
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.getEnterprise_EnterprisePartner();
  }
  getEnterprise_EnterprisePartner() {
    this._apiService.get(config.WebApiPath + 'api/getdevicemodel').subscribe(result => {
      debugger;
      if (result.Success === true) {
        debugger;
        this.Enterpriselist = result.Data[0];
        //this.EnterprisePartnerlist = (result.Data[2].filter(X => X.IsActive !== false));



        // this.Enterprisedata = result.Data[2].filter(X => X.EnterprisePartnerCode == 'FKOL')

      }

    },
      error => {
        console.log(error);
      }
    );
  }

  onClick() {

    this.TitleAdd = true;
    this.form.reset();
  }
  editTitle(item: any) {
    this.TitleAdd = false;
  }



  onSubmit() {
    if (this.form.valid) {
      debugger

      this._apiService.post(config.urlpath + 'api/addenterprise', this.form.value).subscribe(result => {
        if (result.Success === true) {
          $('#ModalClsbtn').click();

          this.notifier.notify('success', 'Added Successfully');
        } else {
          this.notifier.notify('error', 'An Error Occured');
        }
      },
        error => {
          console.log(error);
        }
      );


    }
    else {
      this.notifier.notify('warning', 'Please Enter Base Enterprise Name');
    }




  }
}

